import React, { useState } from "react";
import "./FAQ.css";
import { Button } from "antd";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [visibleCount, setVisibleCount] = useState(5);

  const INITIAL_COUNT = 5;
  const LOAD_STEP = 5;

  const faqData = [
    {
      question: "What is BeyondSchools?",
      answer:
        "BeyondSchools is a digital learning platform designed for Primary and secondary school students in Tanzania. It provides interactive e-learning resources, including video lessons, quizzes, past papers and to enhance learning outcomes.",
    },
    {
      question: "How can students access BeyondSchools?",
      answer:
        "Students can access BeyondSchools via Website: www.beyondschools.co.tz And Mobile App: Available on Google Play Store (Android) and App Store (iOS).",
    },
    {
      question: "Is BeyondSchools free?",
      answer:
        "The platform offers both free and premium (paid) content, Some resources are freely accessible, while others require a subscription with affordable prices.",
    },
    {
      question: "What subjects are available on BeyondSchools?",
      answer:
        "The platform covers Tanzanian secondary school syllabi, including: •	Science: Mathematics, Physics, Chemistry, Biology •	Arts & Humanities: History, Geography, English, Kiswahili •	Commerce: Bookkeeping, Commerce •	Vocational Skills: ICT, Entrepreneurship",
    },
    {
      question: "Can teachers use BeyondSchools?",
      answer:
        "Yes! Teachers can:, live Q&A sessions, •	Access teaching resources.",
    },
    {
      question: "How does BeyondSchools support offline learning?",
      answer:
        "Students can download lessons for offline use via the app.",
    },
    {
      question: "Is BeyondSchools aligned with NECTA?",
      answer:
        "Yes! The platform follows the Tanzanian national curriculum and includes NECTA past papers and exam-style questions for Form 2, Form 4, and Form 6 students.",
    },
     {
      question: "What devices are compatible?",
      answer:
        "BeyondSchools works on: •Smartphones (Android/iOS)- via Mobile App and web browser, •Tablets (via Mobile App and web browser) •Computers/Laptops (via web browser)",
    },
     {
      question: "Does BeyondSchools work in rural areas with poor internet?",
      answer:
        "Yes! The platform offers: •Low-bandwidth mode for slow connections, •Offline access to downloaded materials •Computers/Laptops (via web browser)",
    },
    {
      question: "Can students interact with teachers online?",
      answer:
        "Yes! Features include: Discussion forums for peer learning"
    }
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

 const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 5); // load 5 more each time
  };

   const handleLoadLess = () => {
    setVisibleCount(INITIAL_COUNT);
    setActiveIndex(null); // Optionally collapse open FAQs
  };

  return (
    <div className="faq-page-container">
      <div className="faq-content">
        <div className="faq-container">
          <div className="faq-list">
           {faqData.slice(0, visibleCount).map((item, index) => (
                <div key={index} className="faq-item">
                  <div
                    className="faq-question"
                    onClick={() => toggleAnswer(index)}
                  >
                    {item.question}
                    <span className="faq-icon">
                      {activeIndex === index ? "-" : "+"}
                    </span>
                  </div>
                  {activeIndex === index && (
                    <div className="faq-answer">{item.answer}</div>
                  )}
                </div>
              ))}

            <div style={{ marginTop: "1rem" }}>
              {visibleCount < faqData.length && (
                <button className="load-more-button" onClick={handleLoadMore}>
                  Load More
                </button>
              )}
              {visibleCount > INITIAL_COUNT && (
                <button className="load-less-button" onClick={handleLoadLess} style={{ marginLeft: "10px" }}>
                  Load Less
                </button>
                )}
      </div>
          </div>
        </div>
        <div className="faq-illustration">
          <h1 className="faq-title">Frequently Asked Questions</h1>
          <div className="faq-subtitle">
              <p className="faq-description">Have questions about our beyondschools digital learning platform? Here are some
              common queries answered for you.</p>
              <p className="faq-description-bold">Still Having questions?</p>
                <span className="faq-help">Please send as an email we will be happy to listen</span>
                {/* <Button className="faq-contact-button" onClick={handleEmailClick}>Contact Us</Button> */}
              </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;